import { useI18n } from "@core/i18n/i18n";
import { HealthcareTeamMember, HealthcareTeamMemberStatus } from "@domain/healthcare-team/healthcare-team";
import styled from "@emotion/styled";
import { WordingKey } from "@typings/i18n-typings";
import { Tooltip } from "@ui/components/common/tooltip";
import { colors } from "@ui/style/colors";
import { isNil } from "@utils/assert";
import React from "react";

interface HealthcareTeamMemberTagProps {
	member: HealthcareTeamMember;
}

const statusWordings = {
	PENDING_PT_REGISTRATION: {
		tag: "patientDetails.healthcareTeam.listItem.status.unregistered",
		tooltip: "patientDetails.healthcareTeam.listItem.status.unregistered.tooltip",
	},
	PENDING_PATIENT_VALIDATION: {
		tag: "patientDetails.healthcareTeam.listItem.status.pendingPatientValidation",
		tooltip: "patientDetails.healthcareTeam.listItem.status.pendingPatientValidation.tooltip",
	},
	PENDING_PT_VALIDATION: {
		tag: "patientDetails.healthcareTeam.listItem.status.pendingPtValidation",
		tooltip: "patientDetails.healthcareTeam.listItem.status.pendingPtValidation.tooltip",
	},
	CONFIRMED: undefined,
} satisfies Record<HealthcareTeamMemberStatus, { tag: WordingKey; tooltip: WordingKey } | undefined>;

export const HealthcareTeamMemberTag = ({ member }: HealthcareTeamMemberTagProps): JSX.Element => {
	const { format } = useI18n();

	const wordings = statusWordings[member.status];

	if (isNil(wordings)) {
		return <></>;
	}

	return (
		<Tooltip content={format(wordings.tooltip)} placement={"auto"}>
			<TagContainer>{format(wordings.tag)}</TagContainer>
		</Tooltip>
	);
};

const TagContainer = styled.div`
	white-space: nowrap;
	padding: 4px 16px;
	border-radius: 3.25rem;
	border: 1px solid ${colors.warnDark};
	color: ${colors.warnDark};
	background-color: ${colors.warn};
`;
